import { FC, ReactElement } from 'react';
import { useState } from 'react';
import HanTab, { IProps as HanTabProps } from './HanTab';
import Breadcrumbs from '../Breadcrumbs';

interface IProps {
    /**
     * @description Converted the type of the children to ReactElements with the properties of the HanTab-componetn. 
     * Not necessary, but this way the properties of HanTab.tsx are visible with IntelliSense. It is an array because there are
     * always multiple tabs.
     */
    children: ReactElement<HanTabProps>[],
    title: string,
    breadcrumbs?: {name: string, url: string}[]
}

/**
 * @param children: ReactElement<HanTabProps>[]
 * @param title
 * @param breadcrumbs
 * @param title
 * @param breadcrumbs
 * @description This is the container for both the tabs and the tab-titles. This component uses every HanTab-component to create a
 * panel and tab and only shows the one that is active.
 */
const HanTabs: FC<IProps> = ({ children, title, breadcrumbs }) => {
    const [activeTab, setActiveTab] = useState<string>(children[0].props.title);

    return (
        <div className="han-tabs">
            <div className="han-tabs__head">
                <div>
                    <h1 className="han-tabs__title">{title}</h1>

                    {
                        breadcrumbs &&
                        <Breadcrumbs breadcrumbs={breadcrumbs} />
                    }
                </div>

                <div className="han-tabs__tab-titles">
                    {
                        children.map((child, index) => {
                            return (
                                <div
                                    className={`han-tabs__tab-title ${child.props.title === activeTab ? "han-tabs__tab-title--active" : ""}`}
                                    key={`tab-title-${index}`}
                                    onClick={() => setActiveTab(child.props.title)}
                                >
                                    {child.props.title}
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            {
                children.map(child => {
                    return child.props.title === activeTab ? child : ""
                })
            }
        </div>
    )
}

export default HanTabs

export {
    HanTab
}
